import React, { useEffect, createElement } from 'react';
export function SEO() {
  useEffect(() => {
    // Update Title
    document.title = "Smart Market Digital | UK's Leading SEO & Digital Marketing Agency";
    // Helper function to create or update meta tags
    const setMetaTag = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    // Basic SEO Meta Tags
    setMetaTag('description', 'Transform your online presence with Smart Market Digital. Expert SEO, PPC & digital marketing services in the UK. Get more traffic, leads & sales. Contact us on WhatsApp today!');
    setMetaTag('keywords', 'SEO services UK, digital marketing agency, PPC management, social media marketing, local SEO, web design UK, Smart Market Digital');
    setMetaTag('author', 'Smart Market Digital');
    // Robots Meta Tag - Allow full indexing and crawling
    setMetaTag('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setMetaTag('googlebot', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setMetaTag('bingbot', 'index, follow');
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://smartmarketdigital.com/');
    // Open Graph Meta Tags (for social sharing)
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', 'https://smartmarketdigital.com/', true);
    setMetaTag('og:title', "Smart Market Digital | UK's Leading SEO & Digital Marketing Agency", true);
    setMetaTag('og:description', 'Transform your online presence with Smart Market Digital. Expert SEO, PPC & digital marketing services in the UK.', true);
    setMetaTag('og:site_name', 'Smart Market Digital', true);
    setMetaTag('og:locale', 'en_GB', true);
    // Twitter Card Meta Tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', "Smart Market Digital | UK's Leading SEO Agency");
    setMetaTag('twitter:description', 'Expert SEO, PPC & digital marketing services in the UK. Get more traffic, leads & sales.');
    // Additional SEO Meta Tags
    setMetaTag('geo.region', 'GB');
    setMetaTag('geo.placename', 'United Kingdom');
    setMetaTag('language', 'English');
    setMetaTag('revisit-after', '7 days');
    setMetaTag('rating', 'general');
    // Add JSON-LD Schemas (expanded)
    const schemaData = {
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': 'Organization',
        '@id': 'https://smartmarketdigital.com/#organization',
        name: 'Smart Market Digital',
        url: 'https://smartmarketdigital.com',
        logo: {
          '@type': 'ImageObject',
          url: 'https://smartmarketdigital.com/logo.png',
          width: 200,
          height: 60
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+44-7921-876472',
          contactType: 'customer service',
          areaServed: 'GB',
          availableLanguage: 'English'
        },
        sameAs: ['https://wa.me/447921876472']
      }, {
        '@type': 'LocalBusiness',
        '@id': 'https://smartmarketdigital.com/#localbusiness',
        name: 'Smart Market Digital',
        image: 'https://smartmarketdigital.com/logo.png',
        telephone: '+44 7921 876472',
        url: 'https://smartmarketdigital.com',
        areaServed: {
          '@type': 'Country',
          name: 'United Kingdom'
        },
        priceRange: '££',
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00'
        }
      }, {
        '@type': 'WebSite',
        '@id': 'https://smartmarketdigital.com/#website',
        url: 'https://smartmarketdigital.com',
        name: 'Smart Market Digital',
        description: "UK's Leading SEO & Digital Marketing Agency",
        publisher: {
          '@id': 'https://smartmarketdigital.com/#organization'
        },
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://smartmarketdigital.com/?s={search_term_string}',
          'query-input': 'required name=search_term_string'
        }
      }, {
        '@type': 'WebPage',
        '@id': 'https://smartmarketdigital.com/#webpage',
        url: 'https://smartmarketdigital.com',
        name: "Smart Market Digital | UK's Leading SEO & Digital Marketing Agency",
        isPartOf: {
          '@id': 'https://smartmarketdigital.com/#website'
        },
        about: {
          '@id': 'https://smartmarketdigital.com/#organization'
        },
        description: 'Transform your online presence with Smart Market Digital. Expert SEO, PPC & digital marketing services in the UK.'
      }, {
        '@type': 'Service',
        '@id': 'https://smartmarketdigital.com/#seo-service',
        name: 'Search Engine Optimization (SEO)',
        provider: {
          '@id': 'https://smartmarketdigital.com/#organization'
        },
        areaServed: 'United Kingdom',
        description: 'Professional SEO services to increase organic traffic and rankings on Google.',
        serviceType: 'SEO Services'
      }, {
        '@type': 'Service',
        '@id': 'https://smartmarketdigital.com/#ppc-service',
        name: 'PPC Advertising',
        provider: {
          '@id': 'https://smartmarketdigital.com/#organization'
        },
        areaServed: 'United Kingdom',
        description: 'High-ROI Google Ads and social media paid advertising campaigns.',
        serviceType: 'PPC Management'
      }, {
        '@type': 'Service',
        '@id': 'https://smartmarketdigital.com/#smm-service',
        name: 'Social Media Marketing',
        provider: {
          '@id': 'https://smartmarketdigital.com/#organization'
        },
        areaServed: 'United Kingdom',
        description: 'Build brand awareness and engage your audience across social platforms.',
        serviceType: 'Social Media Marketing'
      }, {
        '@type': 'FAQPage',
        '@id': 'https://smartmarketdigital.com/#faq',
        mainEntity: [{
          '@type': 'Question',
          name: 'What SEO services does Smart Market Digital offer?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We offer comprehensive SEO services including technical SEO, on-page optimization, content marketing, link building, and local SEO for UK businesses.'
          }
        }, {
          '@type': 'Question',
          name: 'How can I contact Smart Market Digital?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'You can contact us directly via WhatsApp at +44 7921 876472 for instant support and consultation.'
          }
        }]
      }]
    };
    let scriptTag = document.querySelector('#schema-json-ld');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = 'schema-json-ld';
      scriptTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(schemaData);
  }, []);
  return null;
}